export const AFFILIATE_CONFIG = {
  COMMISSION_RATE: 0.15,        // 15%
  MIN_PAYOUT: 20,               // $20 USD mínimo
  COOKIE_DAYS: 30,              // Tracking de 30 días
  PAYMENT_METHOD: 'paypal',
  ABSORB_FEES: true,            // Rankaro paga las comisiones PayPal
  COOKIE_NAME: 'rankaro_ref',
  REFERRAL_DISCOUNT: 0.30,     // 30% descuento primer mes para referidos
} as const;

export function getRefCodeFromCookie(): string | null {
  const cookies = document.cookie.split(';');
  const refCookie = cookies.find(c => c.trim().startsWith(`${AFFILIATE_CONFIG.COOKIE_NAME}=`));
  return refCookie ? refCookie.split('=')[1]?.trim() || null : null;
}

export function setRefCodeCookie(code: string): void {
  const maxAge = AFFILIATE_CONFIG.COOKIE_DAYS * 24 * 60 * 60;
  document.cookie = `${AFFILIATE_CONFIG.COOKIE_NAME}=${code}; max-age=${maxAge}; path=/; SameSite=Lax`;
}

export function clearRefCodeCookie(): void {
  document.cookie = `${AFFILIATE_CONFIG.COOKIE_NAME}=; max-age=0; path=/`;
}
